const modalReducer = (
    state = { modalData: null, viewAsUser: null, rModalOpened: false, loading: false, error: false, deletedDatumId: null }, 
    action
)   => {
        switch(action.type) {
            
            // I think this should have start, success, and fail just like the user and item
            case "MODAL_LOAD":
                return{...state, modalData: action.modalPackage, rModalOpened: true};
            
            case "MODAL_FETCH_USER_START":
                return{...state, loading: true, rModalOpened: true, error: false};
            case "MODAL_FETCH_USER_SUCCESS":
                // console.log("MODAL_FETCH_USER_SUCCESS")
                // console.log(action.data);
                return{...state, modalData: {modalType: "user", data: action.data}, rModalOpened: true, loading: false};
            case "MODAL_FETCH_USER_FAIL":
                return{...state, modalData: {modalType: "error"}, rModalOpened: false, loading: false, error: true};
            

            case "MODAL_FETCH_ITEM_START":
                // console.log("MODAL_FETCH_ITEM_START")
                return{...state, loading: true, rModalOpened: true, error: false};
            case "MODAL_FETCH_ITEM_SUCCESS":
                // console.log("MODAL_FETCH_ITEM_SUCCESS")
                // console.log(action.data);
                return{...state, modalData: {modalType: "item", data: action.data}, rModalOpened: true, loading: false};
            case "MODAL_SET_RELATIONAL_DATA":
                return {
                    ...state,
                    modalData: {
                        ...state.modalData,
                        data: {
                            ...state.modalData.data,
                            relationalItems: action.payload.relationalItems,
                            suggestions: action.payload.suggestions
                        }
                    }
                };
            case "MODAL_FETCH_ITEM_FAIL":
                return{...state, modalData: {modalType: "error"}, rModalOpened: false, loading: false, error: true};
            
            case "MODAL_ITEM_VIEW_START":
                return{...state, loading: true, rModalOpened: true, error: false};
            
            case "MODAL_ITEM_VIEW_SUCCESS":
                return {...state, modalData: action.data, rModalOpened: true, loading: false};
            
            case "MODAL_ITEM_VIEW_FAIL":
                return{...state, modalData: {modalType: "error"}, rModalOpened: false, loading: false, error: true};
            case "DATUM_DELETED":
                return { ...state, deletedDatumId: action.datumId}
            
            case "MODAL_CLOSE":
                return{...state, deletedDatumId: null, rModalOpened: false};

            case 'SET_VIEW_AS_USER':
                return { ...state, viewAsUser: action.payload }
            
            case 'CLEAR_VIEW_AS_USER':
                return { ...state, viewAsUser: null }

            case "LOG_OUT":
            return {modalData: null, rModalOpened: false, loading: false, error: false}

            default: 
                return state
        }
        
    };

export default modalReducer;